/** `device type` values used in HEADER.UVO_DEVICE_TYPE. */
export enum DeviceType {
  MobileTabletFallback = 'unknown', // Mobile / tablet when phone vs tablet cannot be determined
  Desktop = 'desktop',
  Phone = 'mobile',
  Tablet = 'tablet',
}
